export default __webpack_public_path__ + "static/media/1150.80cf3226.png";